<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-toolbar flat color="white">
      <v-toolbar-title>Investor Calculator Setting</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <!-- <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Investor Calculator Setting</v-btn>
        </template> -->
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.lower_fund_range" label="Lower Fund Range"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.upper_fund_range" label="Upper Fund Range"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.increment" label="Increment"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.avg_fund_size" label="Average Fund Size"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.avg_fund_duration" label="Average Fund Duration"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.lower_duration" label="Lower Duration"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.upper_duration" label="Upper Duration"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.range_for_funding" label="Range For Funding"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.shadhin_community_fee" label="Shadhin Community Fee"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.provision_for_loss" label="Provision For Loss"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.defaults" label="Defaults"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.annual_roi_lower_range" label="Lower Range of Annual ROI"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.annual_roi_upper_range" label="Upper Range of Annual ROI"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.lower_fund_range }}</td>
        <td class="text-xs-center">{{ props.item.upper_fund_range }}</td>
        <td class="text-xs-center">{{ props.item.increment }}</td>
        <td class="text-xs-center">{{ props.item.avg_fund_size }}</td>
        <td class="text-xs-center">{{ props.item.avg_fund_duration }}</td>
        <td class="text-xs-center">{{ props.item.lower_duration }}</td>
        <td class="text-xs-center">{{ props.item.upper_duration }}</td>
        <td class="text-xs-center">{{ props.item.range_for_funding }}</td>
        <td class="text-xs-center">{{ props.item.shadhin_community_fee }}</td>
        <td class="text-xs-center">{{ props.item.provision_for_loss }}</td>
        <td class="text-xs-center">{{ props.item.defaults }}</td>
        <td class="text-xs-center">{{ props.item.annual_roi_lower_range }}</td>
        <td class="text-xs-center">{{ props.item.annual_roi_upper_range }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <!-- <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon> -->
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'calculator-setting',
      headers: [
        { text: 'Lower Fund Range', align: 'center', sortable: false, value: 'lower_fund_range' },
        { text: 'Upper Fund Range', align:'center',value: 'upper_fund_range' },
        { text: 'Increment', align:'center',value: 'increment' },
        { text: 'Avg Fund Size', align:'center',value: 'avg_fund_size' },
        { text: 'Avg Fund Duration', align:'center',value: 'avg_fund_duration' },
        { text: 'Lower Duration', align:'center',value: 'lower_duration' },
        { text: 'Upper Duration', align:'center',value: 'upper_duration' },
        { text: 'Funding Range', align:'center',value: 'range_for_funding' },
        { text: 'Shadhin Community Fee', align:'center',value: 'shadhin_community_fee' },
        { text: 'Provision For Loss', align:'center',value: 'provision_for_loss' },
        { text: 'Defaults', align:'center',value: 'defaults' },
        { text: 'Annual ROI Lower Range', align:'center',value: 'annual_roi_lower_range' },
        { text: 'Annual ROI Upper Range', align:'center',value: 'annual_roi_upper_range' },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: {
        lower_fund_range: '',
        upper_fund_range: '',
        increment: '',
        avg_fund_size: '',
        avg_fund_duration: '',
        lower_duration: '',
        upper_duration: '',
        range_for_funding: '',
        shadhin_community_fee: '',
        provision_for_loss: '',
        defaults: '',
        annual_roi_lower_range: '',
        annual_roi_upper_range: '',
      },
      defaultItem: {
       title: ''
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg', 'investorAgreement', 'investeeAgreement', 'userImage', 'docImage']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Investor Calculator Setting' : 'Edit Investor Calculator Setting'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      }
    }
  }
</script>